export default {
    index: '/',
    about: {
        index: '/about'
    },
    news: {
        index: '/news',
        show: '/news/{post}'
    },
    downloads: {
        index: '/downloads',

        photos: {
            index: '/downloads/photos'
        },
        videos: {
            index: '/downloads/videos'
        },
        audios: {
            index: '/downloads/audios'
        }
    }
}
